import { useEffect, useState } from "react";
import { getApiBase } from "../utils/apiBase";

const API_BASE = getApiBase();

const DEFAULT_STATE = {
  isLoading: true,
  showPirateFlag: false,
};

export const useQubiqRepublicVisual = () => {
  const [state, setState] = useState(DEFAULT_STATE);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(`${API_BASE}/ui/flags/qubiq-republic`, {
          credentials: "include",
        });
        const data = await res.json().catch(() => ({}));

        if (!cancelled) {
          setState({
            isLoading: false,
            showPirateFlag: Boolean(res.ok && data?.showPirateFlag),
          });
        }
      } catch {
        if (!cancelled) {
          setState({
            isLoading: false,
            showPirateFlag: false,
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};

export default useQubiqRepublicVisual;
